var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import clsx from 'clsx';
const TooltipToggleCore = React.forwardRef(function TooltipToggleCore(props, ref) {
    const { components: { Icon }, children, id, className, icon, color, onClick } = props, rest = __rest(props, ["components", "children", "id", "className", "icon", "color", "onClick"]);
    return (React.createElement("button", Object.assign({}, rest, { className: clsx('tooltip-toggle', {
            ['tooltip-toggle--icon']: !!icon,
            [`tooltip-toggle--${color}`]: !!color,
        }, className), type: "button", id: id, ref: ref, 
        // Prevent click events from propagating to parents
        onClick: e => {
            e.stopPropagation();
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        } }),
        React.createElement("span", { className: "tooltip-toggle__inner" },
            React.createElement("span", { className: "tooltip-toggle__text" }, children),
            icon && React.createElement(Icon, { modifiers: "#help", className: "tooltip-toggle__icon", size: "xs" }))));
});
export default TooltipToggleCore;
